import { render, staticRenderFns } from "./AutomatedConfigEditor.vue?vue&type=template&id=dc35122c&"
import script from "./AutomatedConfigEditor.vue?vue&type=script&lang=js&"
export * from "./AutomatedConfigEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports